module.exports = __webpack_public_path__ + "static/media/Shadow Shaman.786ea2eb.png";